import { apiSlice } from "./apiSlice";

export const auctionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createAuction: builder.mutation({
      query: (auctionData) => ({
        url: "/auctions/createAuction",
        method: "POST",
        body: auctionData,
      }),
      invalidatesTags: ["Auction"],
    }),

    deleteAuction: builder.mutation({
      query: (id) => ({
        url: `/auctions/deleteAuction/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Auction"],
    }),

    updateAuction: builder.mutation({
      query: ({ auctionData, id }) => ({
        url: `/auctions/updateAuction/${id}`,
        method: "PATCH",
        body: auctionData,
      }),
      invalidatesTags: ["Auction"],
    }),

    getAllAuctions: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/auctions/getAllAuctions?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Auction"],
    }),
    getAuctionById: builder.query({
      query: (id) => ({
        url: `/auctions/getAuctionById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateAuctionMutation,
  useUpdateAuctionMutation,
  useDeleteAuctionMutation,
  useGetAllAuctionsQuery,
  useGetAuctionByIdQuery,
} = auctionApi;
